import React, {useState} from 'react';
import { NavLink, useNavigate, Link } from 'react-router-dom';
import BaseCard from 'src/app/components/commonComponents/BaseCard';
import Footer from 'src/app/components/commonComponents/Footer';
import {FullScreenLoader, Header} from 'src/app/components';
import ProfileImageView from 'src/app/components/commonComponents/ProfileImageView';
import TabNavigation from 'src/app/components/commonComponents/TabNavigation';
import ConfirmationModal from 'src/app/components/modals/ConfirmationModal';
import { BookingIcon, EyMemoryIcon, HomeLearningIcon, InvoicePaymentIcon, PowerIcon, ProfileIcon, ScanIcon, SettingsIcon } from 'src/app/static/images/svg';
import { AppRoutes } from 'src/app/navigation/routes';
import { store, useAppDispatch, useAppSelector } from 'src/app/services/store';
import { getCurrentChild, getIsAuthLoading, getLoggedInUserEmail, getShowDownloadAppBanner, logout } from 'src/shared/redux-state/src';
import { getBookingURL } from 'src/shared/services/src';
import { AxiosError } from 'axios';
import { ChildrenStoreData } from 'src/shared/types/src';
import { toast } from 'react-toastify';
import { APP_MESSAGES } from 'src/shared/config/src';
import { navigateToDownloadAppScreen, useWindowWidth } from 'src/app/utilities/helpers';
import { usePreviousRoute } from 'src/app/guards/PreviousRouteContext';

const OptionsScreen = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { clearPreviousRoute } = usePreviousRoute();

  const currentChild: ChildrenStoreData = useAppSelector(getCurrentChild);
  const loggedInUserEmail: string = useAppSelector(getLoggedInUserEmail);
  const showDownloadAppBanner: boolean = useAppSelector(getShowDownloadAppBanner);
  const isAuthLoading: boolean = useAppSelector(getIsAuthLoading);
  const width = useWindowWidth();

  const [isLogoutModal, setIsLogoutModal] = useState<boolean>(false);
  const [loading, setLoading] = useState(false)

  const toggleLogoutConfirmModal = () => {
    setIsLogoutModal(!isLogoutModal);
  }

  const confirmLogout = async () => {
    const platform = 'WEB'
    await dispatch(logout({ reduxStore: store, platform }));
    setIsLogoutModal(false);
    clearPreviousRoute();
    navigate(AppRoutes.VERIFY_EMAIL);
  }

  const onPressBooking = async () => {
    try {
      setLoading(true);

      const response = await getBookingURL({
        child: currentChild
      });

      if (response && response.url) {
        navigate(AppRoutes.BOOKINGS, { state: { url: response?.url, headerTitle: 'Bookings'}});
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        const { errors } = error?.response?.data;
        if (errors && Object.keys(errors).length > 0) {
          toast.error(errors.join(", "), { autoClose: 5000 });
        } else {
          toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
        }
      } else {
        toast.error(APP_MESSAGES.generalErrorMessage, { autoClose: 5000 });
      }
    } finally {
      setLoading(false)
    }
  };

  const onPressEyMemories = () => {
    navigate(AppRoutes.EYMEMORIES, { state: { headerTitle: 'eymemories' }});
  }
  
  // const getMemoriesURL = async (link: string) => {
  //   try {
  //     setLoading(true);

  //     const response = await getEyMemoriesURL({
  //       child: currentChild,
  //       payload: {
  //         token: link
  //       }
  //     });

  //     if (response && response?.url) {
  //       // navigation.navigate(APP_SCREEN.WEB_VIEW, {
  //       //     url: response?.url,
  //       //     handleNavigationChange: () => { },
  //       //     handleOnMessageChange: () => { },
  //       //     webViewTitle: 'EyMemories'
  //       // });

  //       await openLink(
  //         response?.url,
  //         appTheme.dark ? 'dark-content' : 'dark-content',
  //       );
  //     } else {
  //       setApiError(true)
  //     }

  //   } catch (error) {
  //     if (error instanceof AxiosError) {
  //       const { errors } = error.response?.data;
  //       if (errors && Object.keys(errors).length > 0) {
  //         setApiError(true);
  //         setApiErrorMsg(JSON.stringify(errors));
  //       } else {
  //         setApiError(true);
  //         setApiErrorMsg(JSON.stringify(error));
  //       }
  //     } else {
  //       setApiError(true);
  //       setApiErrorMsg(JSON.stringify(error));
  //     }
  //   } finally {
  //     setLoading(false)
  //   }

  // };

  // const requestCameraPermission = async () => {
  //   try {
  //     const response = await request(Platform.OS === 'android' ? PERMISSIONS.ANDROID.CAMERA : PERMISSIONS.IOS.CAMERA);
  //     return response
  //   } catch (error) {
  //     console.log("Camera Permission Error", error);
  //     setApiErrorMsg('Camera permission not granted. Please provide permission from settings.')
  //     setApiError(true);
  //   }
  // };

  // const onPressShowScanner = async () => {
  //   const permissionReq = await requestCameraPermission();

  //   if (RESULTS.GRANTED === permissionReq || RESULTS.LIMITED === permissionReq) {
  //     setShowScanner(true)
  //   }
  // }

  // const onError = (error: CameraRuntimeError) => {
  //   setApiErrorMsg(APP_MESSAGES.generalErrorMessage)
  //   setApiError(true);
  // }

  // const onSuccessBarCode = async (link: string) => {
  //   if (link) {
  //     await getMemoriesURL(link)
  //   }
  // }

  return (
    <div className={`main-wrapper bg-white container  ${showDownloadAppBanner ? (width > 567 ? 'pd-t-86' : 'pd-t-92') : 'pd-t-50'} pd-b-70`}>
      {loading ? <FullScreenLoader /> : null}
      <Header />
      <div className='flex-1'>
        {
          (currentChild?.systemsEnabled?.eymanage && currentChild?.systemAccess?.eymanage) ?
            <Link to={AppRoutes.BASIC_PROFILE} className="text-decoration-none d-block mg-t-15">
              <BaseCard>
                <p className='fs-14 fw-semibold text-black d-flex align-items-center mb-0'><ProfileIcon /> <span className='mg-l-15'>Child Profile</span></p>
              </BaseCard>
            </Link> 
          : null
        }
        {
          (currentChild?.systemsEnabled?.eymanage && currentChild?.systemAccess?.eymanage) ?
            <div className="text-decoration-none d-block mg-t-15 cursor-pointer" onClick={onPressBooking}>
              <BaseCard>
                <p className='fs-14 fw-semibold text-black d-flex align-items-center mb-0'><BookingIcon /> <span className='mg-l-15'>Sessions</span></p>
              </BaseCard>
            </div> 
          : null
        }
        {
          (currentChild?.systemsEnabled?.eymanage && currentChild?.systemAccess?.eymanage) ?
            <NavLink to={AppRoutes.INVOICE} className="text-decoration-none d-block mg-t-15">
              <BaseCard>
                <p className='fs-14 fw-semibold text-black d-flex align-items-center mb-0'><InvoicePaymentIcon /> <span className='mg-l-15'>Invoice and Payments</span></p>
              </BaseCard>
            </NavLink> 
          : null
        }
        {
          (currentChild?.systemsEnabled?.eylog && currentChild?.systemAccess?.eylog) ?
            <NavLink to={AppRoutes.PLANNING} className="text-decoration-none d-block mg-t-15">
              <BaseCard>
                <p className='fs-14 fw-semibold text-black d-flex align-items-center mb-0'><HomeLearningIcon /> <span className='mg-l-15'>Home Learning</span></p>
              </BaseCard>
            </NavLink>
          : null
        }
        <div className='d-flex align-items-center optionScreen-two-icon'>
          <div className="text-decoration-none d-block mg-t-15 cursor-pointer" onClick={onPressEyMemories}>
            <BaseCard>
              <p className='fs-14 fw-semibold text-black d-flex align-items-center mb-0'><EyMemoryIcon /> <span className='mg-l-15'>eymemories</span></p>
            </BaseCard>
          </div>
          <div>
            <div className="text-decoration-none d-block mg-t-15 d-flex align-items-center justify-content-center w-100 cursor-pointer" onClick={navigateToDownloadAppScreen}>
              <BaseCard>
                <ScanIcon />
              </BaseCard>
            </div>
          </div>
        </div>
        <NavLink to={AppRoutes.NOTIFICATIONS_SETTINGS} className="text-decoration-none d-block mg-t-15">
          <BaseCard>
            <p className='fs-14 fw-semibold text-black d-flex align-items-center mb-0'><SettingsIcon /> <span className='mg-l-15'>Settings</span></p>
          </BaseCard>
        </NavLink> 
        <div className='login-details mg-t-30 text-center'>
          <p className='fs-12 mg-b-0'>Logged in as</p>
          <span className='fs-12 text-primary d-block email-logged-in'>{loggedInUserEmail}</span>
        </div>
        <div className="text-decoration-none d-block mg-t-15">
          <BaseCard onPressFunc={toggleLogoutConfirmModal} clickable={true}>
            <p className='fs-14 fw-semibold text-black d-flex align-items-center justify-content-center mb-0'><PowerIcon /> <span className='mg-l-15'>Logout</span></p>
          </BaseCard>
        </div>
        <div className='mg-y-30 d-flex flex-column align-items-center'>
          <ProfileImageView 
            imageUrl={currentChild?.nursery?.logo}
            customContainerStyles={'optionScreen-nursery-img'}
            resizeMode={'contain'}
          />
          <p className='mg-b-0 text-black fs-14 mg-t-5'>{currentChild?.nursery?.name}</p>
        </div>
      </div>
      <Footer isVersion={true} />
      <TabNavigation />
      {isLogoutModal && <ConfirmationModal
        isModal={isLogoutModal}
        toggleModal={toggleLogoutConfirmModal}
        confirmationText={<p className='pd-y-30'>Are you sure you want to logout?</p>}
        handleConfirmation={confirmLogout}
        popupMinHeight={'auto'}
        modalHeader={'Confirm'}
        primaryBtnText={'Yes'}
        secondaryBtnText={'No'}
        isLoading={isAuthLoading}
      />}
    </div>
  );
};

export default OptionsScreen;
